import React, { useContext } from 'react';
import { Card, Button } from 'react-bootstrap';
import { BsFileEarmarkPdf } from 'react-icons/bs';
import '../styles/styles.css';
import Error from "./Error";
import EnvCtx from "../contexts/EnvCtx";
import { useTranslation } from 'react-i18next'
import CameraCntx from "../contexts/CameraCntx";

const ButtonScaricaPdf = () => {
    const { cciaa, existRiepilogoBAndC } = useContext(EnvCtx);
    let chiaveButton = "SF";
    const { selectedIva, selectedLiteA, totale, totaleB, totaleC, error, showErrorPdf, errorLiteApdf, handleErrorClick, formatNumber, generatePdf } = useContext(CameraCntx);
    const { t } = useTranslation();

    return (
        <div className="button-container row mb-1 me-1 ms-1">
            <Card className="button-card text-black" text="black">
                <div className="row no-gutters align-items-center">
                    <div className="col-md-8">
                        <Card.Body>
                            <div className="row text-center text-md-start">
                                {existRiepilogoBAndC && (
                                    <div className="col-md-6">
                                        <Card.Title className="button-title">{selectedIva === 'IVA_inclusa' ? t("totaleBAndCconIva") : t("totaleBAndCsenzaIva")}</Card.Title>
                                        <Card.Text className="button-amount">€ {formatNumber(totaleB + totaleC)}</Card.Text>
                                    </div>
                                )}
                                <div className={existRiepilogoBAndC ? "col-md-6" : "col-md-12"}>
                                    <Card.Title className="button-title">{selectedIva === 'IVA_inclusa' ? t("totaleconIva") : t("totalesenzaIva")}</Card.Title>
                                    <Card.Text className="button-amount">€ {formatNumber(totale)}</Card.Text>
                                </div>
                                <div className="col-md-12 mt-2">
                                    {error && (showErrorPdf || errorLiteApdf) && <Error errors={[error]} />}
                                </div>
                            </div>
                        </Card.Body>
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-center sezione-div-error">
                        <div className="invisible_div_btn" onClick={() => handleErrorClick(chiaveButton)}>
                            <Button className="button-pdf-button" variant="light" onClick={generatePdf} disabled={!selectedLiteA} style={{ backgroundColor: cciaa ? cciaa.background_colore : "" }}>
                                <BsFileEarmarkPdf className="button-pdf-logo" /> {t("scarica_pdf")}
                            </Button>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
}

export default ButtonScaricaPdf;
